/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { PHDocumentController } from "document-model";
import { ProcessorModule } from "../module.js";
import type { ProcessorModuleAction, ProcessorModulePHState } from "./types.js";

export const ProcessorModuleController = PHDocumentController.forDocumentModel<
  ProcessorModulePHState,
  ProcessorModuleAction
>(ProcessorModule);
